import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import FilterButton from "../../components/Common/FilterButton";
import CampaignList from "../../components/Campaign/CampaignList";
import CampaignFormModal from "../../components/Campaign/CampaignFormModal";
import ListPagination from "../../components/Common/ListPagination";
import CommonStyles from "../../static/styles/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as CampaignActions from "../../store/actions/Campaign";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Button from "sushiweb/Button";
import { isMobile } from "../../utils";
import BulkCityUpload from "../../components/Campaign/BulkCityUpload";
import CampaignCitiesModal from "../../components/Campaign/CampaignCitiesModal";

const useStyles = makeStyles((theme) => ({
  actionBar: {
    ...CommonStyles.actionBar,
    "& > button": {
      marginLeft: "20px",
    },
  },
}));

const Campaign = (props) => {
  const classes = useStyles();
  const [modalState, setModalState] = useState(false);
  const [activeItem, setActiveItem] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.CAMPAIGNS];

  const filterFields = ["id"];

  const handleClick = (type, item) => {
    setActiveItem(item);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getCampaignList(props.activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getCampaignList(props.activeFilters, pageRequest);
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
        return <BulkCityUpload customHandleClose={handleClose} />;
      case "Edit":
        return (
          <CampaignFormModal
            activeItem={activeItem}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "Filter":
        return (
          <CampaignFormModal
            activeItem={activeItem}
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        );
      case "Cities":
        return (
          <CampaignCitiesModal
            activeItem={activeItem}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    props.getCampaignList({});
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <CampaignsViewContainer className="Campaigns-View container">
      <FlexContainer align="flex-start">
        <Heading>Campaigns</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.UPSERT]}>
            <Button
              onClick={() => handleClick("Edit", null)}
              className="sushi-btn ml-12 mr-12"
              data-testid="campaignAddNewBtn"
            >
              New Campaign
            </Button>
          </Permission>
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.BULK_CITIES_UPLOAD]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="campaignAddNewBtn"
            >
              Upload Cities
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <CampaignList
        campaignList={props.campaignList}
        handleClick={handleClick}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && getModal()}
    </CampaignsViewContainer>
  );
};

const CampaignsViewContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { Campaign } = state;
  return {
    campaignList: Campaign.campaignList,
    nextPage: Campaign.nextPage,
    prevPage: Campaign.prevPage,
    activeFilters: Campaign.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCampaignList: bindActionCreators(
      CampaignActions.getCampaignList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Campaign);
